import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\MaintenanceController::index
* @see app/Http/Controllers/Admin/MaintenanceController.php:23
* @route '/admin/maintenance'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/admin/maintenance',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\MaintenanceController::index
* @see app/Http/Controllers/Admin/MaintenanceController.php:23
* @route '/admin/maintenance'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\MaintenanceController::index
* @see app/Http/Controllers/Admin/MaintenanceController.php:23
* @route '/admin/maintenance'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\MaintenanceController::index
* @see app/Http/Controllers/Admin/MaintenanceController.php:23
* @route '/admin/maintenance'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\MaintenanceController::create
* @see app/Http/Controllers/Admin/MaintenanceController.php:127
* @route '/admin/maintenance/create'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/admin/maintenance/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\MaintenanceController::create
* @see app/Http/Controllers/Admin/MaintenanceController.php:127
* @route '/admin/maintenance/create'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\MaintenanceController::create
* @see app/Http/Controllers/Admin/MaintenanceController.php:127
* @route '/admin/maintenance/create'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\MaintenanceController::create
* @see app/Http/Controllers/Admin/MaintenanceController.php:127
* @route '/admin/maintenance/create'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\MaintenanceController::store
* @see app/Http/Controllers/Admin/MaintenanceController.php:141
* @route '/admin/maintenance'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/admin/maintenance',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\MaintenanceController::store
* @see app/Http/Controllers/Admin/MaintenanceController.php:141
* @route '/admin/maintenance'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\MaintenanceController::store
* @see app/Http/Controllers/Admin/MaintenanceController.php:141
* @route '/admin/maintenance'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\MaintenanceController::edit
* @see app/Http/Controllers/Admin/MaintenanceController.php:190
* @route '/admin/maintenance/{maintenance}/edit'
*/
export const edit = (args: { maintenance: number | { id: number } } | [maintenance: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/admin/maintenance/{maintenance}/edit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\MaintenanceController::edit
* @see app/Http/Controllers/Admin/MaintenanceController.php:190
* @route '/admin/maintenance/{maintenance}/edit'
*/
edit.url = (args: { maintenance: number | { id: number } } | [maintenance: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { maintenance: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { maintenance: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            maintenance: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        maintenance: typeof args.maintenance === 'object'
        ? args.maintenance.id
        : args.maintenance,
    }

    return edit.definition.url
            .replace('{maintenance}', parsedArgs.maintenance.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\MaintenanceController::edit
* @see app/Http/Controllers/Admin/MaintenanceController.php:190
* @route '/admin/maintenance/{maintenance}/edit'
*/
edit.get = (args: { maintenance: number | { id: number } } | [maintenance: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\MaintenanceController::edit
* @see app/Http/Controllers/Admin/MaintenanceController.php:190
* @route '/admin/maintenance/{maintenance}/edit'
*/
edit.head = (args: { maintenance: number | { id: number } } | [maintenance: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\MaintenanceController::update
* @see app/Http/Controllers/Admin/MaintenanceController.php:212
* @route '/admin/maintenance/{maintenance}'
*/
export const update = (args: { maintenance: number | { id: number } } | [maintenance: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

update.definition = {
    methods: ["patch"],
    url: '/admin/maintenance/{maintenance}',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\Admin\MaintenanceController::update
* @see app/Http/Controllers/Admin/MaintenanceController.php:212
* @route '/admin/maintenance/{maintenance}'
*/
update.url = (args: { maintenance: number | { id: number } } | [maintenance: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { maintenance: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { maintenance: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            maintenance: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        maintenance: typeof args.maintenance === 'object'
        ? args.maintenance.id
        : args.maintenance,
    }

    return update.definition.url
            .replace('{maintenance}', parsedArgs.maintenance.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\MaintenanceController::update
* @see app/Http/Controllers/Admin/MaintenanceController.php:212
* @route '/admin/maintenance/{maintenance}'
*/
update.patch = (args: { maintenance: number | { id: number } } | [maintenance: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Admin\MaintenanceController::updateStatus
* @see app/Http/Controllers/Admin/MaintenanceController.php:257
* @route '/admin/maintenance/{maintenance}/update-status'
*/
export const updateStatus = (args: { maintenance: number | { id: number } } | [maintenance: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: updateStatus.url(args, options),
    method: 'post',
})

updateStatus.definition = {
    methods: ["post"],
    url: '/admin/maintenance/{maintenance}/update-status',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\MaintenanceController::updateStatus
* @see app/Http/Controllers/Admin/MaintenanceController.php:257
* @route '/admin/maintenance/{maintenance}/update-status'
*/
updateStatus.url = (args: { maintenance: number | { id: number } } | [maintenance: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { maintenance: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { maintenance: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            maintenance: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        maintenance: typeof args.maintenance === 'object'
        ? args.maintenance.id
        : args.maintenance,
    }

    return updateStatus.definition.url
            .replace('{maintenance}', parsedArgs.maintenance.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\MaintenanceController::updateStatus
* @see app/Http/Controllers/Admin/MaintenanceController.php:257
* @route '/admin/maintenance/{maintenance}/update-status'
*/
updateStatus.post = (args: { maintenance: number | { id: number } } | [maintenance: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: updateStatus.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\MaintenanceController::destroy
* @see app/Http/Controllers/Admin/MaintenanceController.php:311
* @route '/admin/maintenance/{maintenance}'
*/
export const destroy = (args: { maintenance: number | { id: number } } | [maintenance: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/admin/maintenance/{maintenance}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\MaintenanceController::destroy
* @see app/Http/Controllers/Admin/MaintenanceController.php:311
* @route '/admin/maintenance/{maintenance}'
*/
destroy.url = (args: { maintenance: number | { id: number } } | [maintenance: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { maintenance: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { maintenance: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            maintenance: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        maintenance: typeof args.maintenance === 'object'
        ? args.maintenance.id
        : args.maintenance,
    }

    return destroy.definition.url
            .replace('{maintenance}', parsedArgs.maintenance.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\MaintenanceController::destroy
* @see app/Http/Controllers/Admin/MaintenanceController.php:311
* @route '/admin/maintenance/{maintenance}'
*/
destroy.delete = (args: { maintenance: number | { id: number } } | [maintenance: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

const maintenance = {
    index: Object.assign(index, index),
    create: Object.assign(create, create),
    store: Object.assign(store, store),
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
    updateStatus: Object.assign(updateStatus, updateStatus),
    destroy: Object.assign(destroy, destroy),
}

export default maintenance